export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./OrcidBulkAssignment.vue?vue&type=template&id=64640a88&"


//////////////////
// WEBPACK FOOTER
// ./src/views/usage/OrcidBulkAssignment.vue?vue&type=template&id=64640a88&
// module id = 1401
// module chunks = 0